import { useTranslation } from "react-i18next";

import { ClientStatus, CreditStatus } from "types";

import classes from "./ClientCreditStatusFilterBar.module.css";
import { ClientStatusFilter } from "./ClientStatusFilterBar";

interface CreditFilterOption {
  id: CreditStatus;
  labelKey: string;
}

const FILTERS_BY_CLIENT_STATUS: Partial<Record<ClientStatus, CreditFilterOption[]>> = {
  ACTIVE: [
    { id: "DRAFT", labelKey: "clientStatusFilters.substatus.active.draft" },
    { id: "NEW_REQUEST", labelKey: "clientStatusFilters.substatus.active.newRequest" },
    {
      id: "INCOMPLETE_DOCUMENTATION",
      labelKey: "clientStatusFilters.substatus.active.incompleteDocumentation",
    },
    { id: "PROCESSING", labelKey: "clientStatusFilters.substatus.active.processing" },
    { id: "APPROVED", labelKey: "clientStatusFilters.substatus.active.approved" },
    {
      id: "PRE_DISBURSEMENT_CHECK",
      labelKey: "clientStatusFilters.substatus.active.preDisbursementCheck",
    },
  ],
  COMPLETED: [
    { id: "DISBURSED", labelKey: "clientStatusFilters.substatus.completed.disbursed" },
    { id: "SETTLED", labelKey: "clientStatusFilters.substatus.completed.settled" },
    { id: "WITHDRAWN", labelKey: "clientStatusFilters.substatus.completed.withdrawn" },
    { id: "REJECTED", labelKey: "clientStatusFilters.substatus.completed.rejected" },
    {
      id: "REJECTED_WK_TEAM",
      labelKey: "clientStatusFilters.substatus.completed.rejectedWkTeam",
    },
  ],
};

export const getCreditRequestFilters = (clientStatus: ClientStatusFilter) =>
  clientStatus === "ALL"
    ? FILTERS_BY_CLIENT_STATUS.ACTIVE ?? []
    : FILTERS_BY_CLIENT_STATUS[clientStatus] ?? [];

export const getDefaultCreditRequestStatus = (clientStatus: ClientStatusFilter) =>
  getCreditRequestFilters(clientStatus)[0]?.id;

interface ClientCreditStatusFilterBarProps {
  clientStatus: ClientStatusFilter;
  value?: CreditStatus;
  onChange: (value?: CreditStatus) => void;
}

const ClientCreditStatusFilterBar = ({
  clientStatus,
  value,
  onChange,
}: ClientCreditStatusFilterBarProps) => {
  const { t } = useTranslation();
  const filters = getCreditRequestFilters(clientStatus);

  if (filters.length === 0) {
    return null;
  }

  return (
    <div className={classes.wrapper}>
      {filters.map((filter) => (
        <button
          key={filter.id}
          type="button"
          className={`${classes.filterButton} ${value === filter.id ? classes.filterButtonActive : ""}`}
          onClick={() => onChange(value === filter.id ? undefined : filter.id)}
        >
          {t(filter.labelKey)}
        </button>
      ))}
    </div>
  );
};

export default ClientCreditStatusFilterBar;
